"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TraceNode = void 0;
/**
 * All nodes reported to the consumer must take this shape
 */
class TraceNode {
  constructor(name, start, end, origin, type) {
    this.n = name;
    this.s = start;
    this.e = end;
    this.o = origin;
    this.t = type;
  }
}
exports.TraceNode = TraceNode;